import React from 'react';
import Footer from './footer.js';
import { Link } from 'react-router-dom';


const Work = () =>{
   
    
    return(
        <div className="container">

        

            <div className="work_links">
                <div className="work_main">
                    <div className="title">
                        <h1 className="section_titles">Explora nuestro trabajo</h1>
                    </div>
                    <div className="work_boxes">
                        <Link to="/motion" className="work_link">Producción y Postproducción</Link>
                        <Link to="/interactive" className="work_link">Tecnología y Software</Link>
                    </div>
                </div>
               
            </div>

           
            <div className="foot">
                <Footer/>
            </div>
           
        </div>
    )

}

export default Work;